import {
  REQUEST_DST_EXTRA_RULES,
  RECEIVE_DST_EXTRA_RULES,
  RECEIVE_DST_EXTRA_RULE,
} from "../actions/dst-extra-rules";

const reducer = (
  state = {
    items: [],
    loading: false,
    item: {},
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_DST_EXTRA_RULES:
      return { ...state, loading: true };
    case RECEIVE_DST_EXTRA_RULES:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_DST_EXTRA_RULE:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
